<template>
    <div>
        <el-dialog
                :title="option.title"
                :visible.sync="show"
                width="30%"
                @close="closeTree"
                append-to-body>
            <div style="padding: 20px">
                <el-row>
                <el-input
                        :placeholder="option.placeholder"
                        v-model="filterText">
                </el-input>
                </el-row>
                <el-row>
                <el-tree :data="treeData" ref="diyTree" :expand-on-click-node="false"
                         class="filter-tree"
                         v-loading="treeloading"
                         show-checkbox
                         :auto-expand-parent="false"
                         :filter-node-method="filterNode"
                         @check="checkNode"
                         :check-strictly="true"
                         :default-checked-keys="defaultChecked"
                         :highlight-current="true" node-key="id" :props="this.defaultProps" accordion
                         :default-expanded-keys="defaultOpen"></el-tree>
                </el-row>
                <el-row style="text-align: right">
                    <el-button type="primary" @click="show = false">确定</el-button>
                </el-row>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    let _kits, _form
    export default {
        data() {

            return {
                treeloading: true,
                show: false,
                option: {
                    title: '树',
                    placeholder: '输入关键字进行过滤',
                },
                treeData: [],
                filterText: '',
                defaultOpen: [],
                defaultChecked: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
            }
        },
        methods: {
            getParentsIds(id) {
                if (id == undefined || id == '') {
                    return []
                }
                let lv = 0
                let ids = []
                let blpd = (arr, id, level) => {
                    try {
                        arr.forEach(a => {
                            ids[level] = a.id
                            if (a.id == id) {
                                lv = level
                                throw new Error('匹配成功')
                            }
                            // 遍历子集
                            if (a.children != undefined && a.children.length > 0) {
                                if (blpd(a.children, id, level + 1)) {
                                    throw new Error('匹配成功')
                                }
                            }
                        })
                        return false
                    } catch (e) {
                        // console.log('匹配完毕')
                        return true
                    }
                }
                blpd(this.treeData, id, lv)
                return ids.splice(0, lv)
            },
            closeTree() {
                let nodes = this.$refs.diyTree.getCheckedNodes()
                if(nodes) {
                    for(let i = 0; i < nodes.length; i++){
                        let node = nodes[i];
                        let pnode = this.$refs.diyTree.getNode(node.pid)
                        if (pnode != null) {
                            let plabel = pnode.label;
                            node.plabel = plabel
                        }
                    }
                }
                //console.log(nodes)
                this.$emit('treeCallBack', nodes)
            },
            filterNode(value, data) {
                if (!value) return true
                return data.label.indexOf(value) !== -1
            },
            checkNode(node, nodes) {
                let checkKeys = this.$refs.diyTree.getCheckedKeys()
                if (checkKeys.length > 1) {
                    this.$refs.diyTree.setCheckedKeys([node.id])
                }
            },
            getDefaultOpen() {
                this.defaultOpen = []
                if(this.treeData!=undefined){
                    if (this.treeData.length > 0) {
                        this.defaultOpen.push(this.treeData[0].id)
                        if (this.treeData[0].children.length > 0) {
                            this.defaultOpen.push(this.treeData[0].children[0].id)
                        }
                    }
                }
            },
            showTree(arr, defaultOpen, option) {
                this.treeloading = true
                this.treeData = arr
                if (option != undefined) {
                    this.option = Object.assign(this.option, option)
                }
                if (defaultOpen != undefined && defaultOpen != '') {
                    this.defaultChecked = [defaultOpen]
                    this.defaultOpen = this.getParentsIds(defaultOpen)
                    if (this.defaultOpen.length == 0) {
                        this.getDefaultOpen(this)
                    }
                } else {
                    this.defaultChecked = []
                    this.getDefaultOpen()
                }
                this.show = true
                this.$nextTick(() => {
                   
                    // for (let i = 0; i < this.$refs.diyTree.store._getAllNodes().length; i++) {
                    //     if (!this.defaultOpen.includes(this.$refs.diyTree.store._getAllNodes()[i].data.id)) {
                    //         this.$refs.diyTree.store._getAllNodes()[i].expanded = false
                    //     }
                    // }
                    //this.$refs.diyTree.setCheckedKeys(this.defaultChecked)
                    this.treeloading = false
                })
            },
        },
        created() {
            _kits = this.$kits()

        },
        mounted() {
            setTimeout(() => {
                this.showTooltip = true
            }, 300)
        },
        computed: {},
        watch: {
            filterText(val) {
                this.$refs.diyTree.filter(val)
            },
        },
    }
</script>

<style scoped>

</style>
